import { render, staticRenderFns } from "./cta_dropup.vue?vue&type=template&id=4d89cbca&scoped=true&"
import script from "./cta_dropup.vue?vue&type=script&lang=js&"
export * from "./cta_dropup.vue?vue&type=script&lang=js&"
import style0 from "./cta_dropup.vue?vue&type=style&index=0&id=4d89cbca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d89cbca",
  null
  
)

export default component.exports